let mockUrl = "https://kp-ipracticeapi.eiceducation.com.cn/api";
import instance from "@/api/resetAxios";
import vm from "@/main";
//板块id
let advaInfo = {
  home: 2,
};
export default async function adverCom(type = "home", config = {}) {
  let { isOnlyPageIfo = false, pageTypeId = "" } = config;
  const getPageType = async () => {
    let res = await instance.get(
      `${mockUrl}/pageType?pId=${advaInfo[type]}`,
    );
    if (!res.data.succ) {
        vm.$message.error(res.data.message || res.data.msg);
      }
    return res.data.result;
  };
  const getPageInfo = async (item) => {
    let res = await instance.get(
       `${mockUrl}/pageInfo?pageTypeId=${item.id}&platform=1`,
    );
    if (!res.data.succ) {
        vm.$message.error(res.data.message || res.data.msg);
      }
    return res.data.result;
  };
  const arrChange = (res1)=>{
    for(let item of res1){
      if(item.moreFieldsValue){
        item.moreFieldsValue = JSON.parse(item.moreFieldsValue)
      }
    }
  }
  if (isOnlyPageIfo) {
    let res1 = (await getPageInfo({ id: pageTypeId })) || [];
    arrChange(res1)
    return res1;
  } else {
    let allInfo = {}
    let result = (await getPageType()) || [];
    for (let item of result) {
      let res1 = (await getPageInfo(item)) || [];
      arrChange(res1)
      allInfo[item.name] = res1
    }
    return allInfo
  }
}



// WEBPACK FOOTER //
// ./src/api/advertisingPosition.js